/*

(function () {
  function ready(fn) {
    if (window.jQuery) {
      window.jQuery(fn);
      return;
    }

    var script = document.createElement('script');
    script.src = 'https://code.jquery.com/jquery-3.7.1.min.js';
    script.onload = function () {
      window.jQuery(fn);
    };
    document.head.appendChild(script);
  }

  ready(function ($) {
    var DRAG_THRESHOLD = 6;

    function fillTrack($slider) {
      $slider.find('.lf-multiple-testimonials__item.is-clone').remove();

      var originals = $slider.find('.lf-multiple-testimonials__item').get();
      if (!originals.length) return;

      var sliderEl = $slider[0];
      var peek = originals[0] ? originals[0].offsetWidth * 0.5 : 80;
      var guard = 0;

      while (sliderEl.scrollWidth < sliderEl.clientWidth + peek && guard < 20) {
        originals.forEach(function (item) {
          if (sliderEl.scrollWidth >= sliderEl.clientWidth + peek) return;
          $(item)
            .clone()
            .addClass('is-clone')
            .attr('aria-hidden', 'true')
            .appendTo($slider);
        });
        guard++;
      }
    }

    function getStep($slider) {
      var items = $slider.children('.lf-multiple-testimonials__item').get();
      if (items.length < 2) return 0;
      return items[1].offsetLeft - items[0].offsetLeft;
    }

    function getActiveIndex($slider) {
      var sliderEl = $slider[0];
      var scrollPadding = parseFloat(window.getComputedStyle(sliderEl).scrollPaddingLeft) || 0;
      var target = sliderEl.scrollLeft + scrollPadding;
      var closest = 0;
      var closestDist = Infinity;

      $slider.children('.lf-multiple-testimonials__item').each(function (i) {
        var dist = Math.abs(this.offsetLeft - target);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });

      return closest;
    }

    function initSlider($slider) {
      fillTrack($slider);

      if ($slider.data('lf-slider')) return;
      $slider.data('lf-slider', true);

      var isDown = false;
      var didDrag = false;
      var startX = 0;
      var scrollLeft = 0;

      $slider.on('mousedown', function (e) {
        if (e.which !== 1) return;
        isDown = true;
        didDrag = false;
        startX = e.pageX;
        scrollLeft = $slider.scrollLeft();
      });

      $(document).on('mousemove.lfTestimonials', function (e) {
        if (!isDown) return;
        var dx = e.pageX - startX;
        if (!didDrag && Math.abs(dx) < DRAG_THRESHOLD) return;
        didDrag = true;
        $slider.addClass('is-dragging');
        e.preventDefault();
        $slider.scrollLeft(scrollLeft - dx);
      });

      $(document).on('mouseup.lfTestimonials', function () {
        if (!isDown) return;
        isDown = false;
        $slider.removeClass('is-dragging');
      });

      $slider.on('click', '.lf-multiple-testimonials__item', function (e) {
        if (didDrag) return;

        var clickedIndex = $slider.children('.lf-multiple-testimonials__item').index(this);
        var activeIndex = getActiveIndex($slider);
        if (clickedIndex === activeIndex) return;

        var step = getStep($slider);
        if (!step) return;

        e.preventDefault();
        $slider[0].scrollBy({
          left: clickedIndex > activeIndex ? step : -step,
          behavior: 'smooth'
        });
      });
    }

    function init(scope) {
      var $root = scope ? $(scope) : $(document);
      $root.find('.lf-multiple-testimonials__slider').each(function () {
        initSlider($(this));
      });
    }

    var resizeTimer;
    $(window).on('resize.lfTestimonials', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        $('.lf-multiple-testimonials__slider').each(function () {
          fillTrack($(this));
        });
      }, 150);
    });

    init();
    $(document).on('shopify:section:load', function (e) {
      init(e.target);
    });
  });
})();

*/




(function () {
  function ready(fn) {
    if (window.jQuery) {
      window.jQuery(fn);
      return;
    }

    var script = document.createElement('script');
    script.src = 'https://code.jquery.com/jquery-3.7.1.min.js';
    script.onload = function () {
      window.jQuery(fn);
    };
    document.head.appendChild(script);
  }

  ready(function ($) {
    var DRAG_THRESHOLD = 6;

    function getOriginals($slider) {
      return $slider.children('.lf-multiple-testimonials__item').not('.is-clone').get();
    }

    function getSetWidth($slider, originalCount) {
      var items = $slider.children('.lf-multiple-testimonials__item').get();
      if (items.length >= originalCount * 2) {
        return items[originalCount].offsetLeft - items[0].offsetLeft;
      }
      return getStep($slider) * originalCount;
    }

    function fillTrack($slider) {
      $slider.find('.lf-multiple-testimonials__item.is-clone').remove();

      var originals = getOriginals($slider);
      if (!originals.length) return;

      var sliderEl = $slider[0];
      var originalCount = originals.length;

      function appendSet() {
        originals.forEach(function (item) {
          $(item)
            .clone()
            .addClass('is-clone')
            .attr('aria-hidden', 'true')
            .appendTo($slider);
        });
      }

      appendSet();
      appendSet();

      var setWidth = getSetWidth($slider, originalCount);
      var sets = 3;
      var guard = 0;

      while (
        sliderEl.scrollWidth < sliderEl.clientWidth + setWidth * 2 &&
        guard < 10
      ) {
        appendSet();
        sets += 1;
        setWidth = getSetWidth($slider, originalCount);
        guard += 1;
      }

      $slider.data('originalCount', originalCount);
      $slider.data('setWidth', setWidth);
      $slider.data('sets', sets);
      goToMiddle($slider);
    }

    function goToMiddle($slider) {
      var setWidth = $slider.data('setWidth');
      var sets = $slider.data('sets');
      if (!setWidth || !sets) return;

      var sliderEl = $slider[0];
      sliderEl.style.scrollBehavior = 'auto';
      sliderEl.scrollLeft = setWidth * Math.floor(sets / 2);
      sliderEl.style.scrollBehavior = '';
    }

    function wrapScroll($slider) {
      var sliderEl = $slider[0];
      var setWidth = $slider.data('setWidth');
      var sets = $slider.data('sets');
      if (!setWidth || sets < 3) return 0;

      var sl = sliderEl.scrollLeft;
      var min = setWidth;
      var max = setWidth * (sets - 1);
      var next = sl;

      while (next < min) next += setWidth;
      while (next >= max) next -= setWidth;

      if (next === sl) return 0;

      sliderEl.style.scrollBehavior = 'auto';
      sliderEl.scrollLeft = next;
      sliderEl.style.scrollBehavior = '';
      return next - sl;
    }

    function getStep($slider) {
      var items = $slider.children('.lf-multiple-testimonials__item').get();
      if (items.length < 2) return 0;
      return items[1].offsetLeft - items[0].offsetLeft;
    }

    function getActiveIndex($slider) {
      var sliderEl = $slider[0];
      var scrollPadding = parseFloat(window.getComputedStyle(sliderEl).scrollPaddingLeft) || 0;
      var target = sliderEl.scrollLeft + scrollPadding;
      var closest = 0;
      var closestDist = Infinity;

      $slider.children('.lf-multiple-testimonials__item').each(function (i) {
        var dist = Math.abs(this.offsetLeft - target);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });

      return closest;
    }

    function initSlider($slider) {
      fillTrack($slider);

      if ($slider.data('lf-slider')) return;
      $slider.data('lf-slider', true);

      var isDown = false;
      var didDrag = false;
      var startX = 0;
      var scrollLeft = 0;
      var wrapTimer;

      $slider.on('mousedown', function (e) {
        if (e.which !== 1) return;
        isDown = true;
        didDrag = false;
        startX = e.pageX;
        scrollLeft = $slider.scrollLeft();
      });

      $(document).on('mousemove.lfTestimonials', function (e) {
        if (!isDown) return;
        var dx = e.pageX - startX;
        if (!didDrag && Math.abs(dx) < DRAG_THRESHOLD) return;
        didDrag = true;
        $slider.addClass('is-dragging');
        e.preventDefault();
        $slider.scrollLeft(scrollLeft - dx);
        scrollLeft += wrapScroll($slider);
      });

      $(document).on('mouseup.lfTestimonials', function () {
        if (!isDown) return;
        isDown = false;
        $slider.removeClass('is-dragging');
        wrapScroll($slider);
      });

      $slider.on('scroll', function () {
        if (isDown) return;
        clearTimeout(wrapTimer);
        wrapTimer = setTimeout(function () {
          wrapScroll($slider);
        }, 80);
      });

      $slider.on('click', '.lf-multiple-testimonials__item', function (e) {
        if (didDrag) return;

        var clickedIndex = $slider.children('.lf-multiple-testimonials__item').index(this);
        var activeIndex = getActiveIndex($slider);
        if (clickedIndex === activeIndex) return;

        var step = getStep($slider);
        if (!step) return;

        e.preventDefault();
        $slider[0].scrollBy({
          left: clickedIndex > activeIndex ? step : -step,
          behavior: 'smooth'
        });
      });
    }

    function init(scope) {
      var $root = scope ? $(scope) : $(document);
      $root.find('.lf-multiple-testimonials__slider').each(function () {
        initSlider($(this));
      });
    }

    var resizeTimer;
    $(window).on('resize.lfTestimonials', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        $('.lf-multiple-testimonials__slider').each(function () {
          fillTrack($(this));
        });
      }, 150);
    });

    init();
    $(document).on('shopify:section:load', function (e) {
      init(e.target);
    });
  });
})();
